(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[662,490,2391],{

/***/ 70423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils_debounce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66604);

/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils_debounce__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 80328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils_ownerWindow__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86852);

/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils_ownerWindow__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 75359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils_useForkRef__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67131);
'use client';


/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils_useForkRef__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 66604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ debounce; }
/* harmony export */ });
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce(func, wait = 166) {
  let timeout;
  function debounced(...args) {
    const later = () => {
      // @ts-ignore
      func.apply(this, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }
  debounced.clear = () => {
    clearTimeout(timeout);
  };
  return debounced;
}

/***/ }),

/***/ 17205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ setRef; }
/* harmony export */ });
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

/***/ }),

/***/ 67131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useForkRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var _setRef__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17205);
'use client';



function useForkRef(...refs) {
  /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(() => {
    if (refs.every(ref => ref == null)) {
      return null;
    }
    return instance => {
      refs.forEach(ref => {
        (0,_setRef__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(ref, instance);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, refs);
}

/***/ }),

/***/ 31508:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings",
      function () {
        return __webpack_require__(81247);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 43276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AsyncSelect; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./components/asyncSelect/asyncSelect.module.scss
var asyncSelect_module = __webpack_require__(25898);
var asyncSelect_module_default = /*#__PURE__*/__webpack_require__.n(asyncSelect_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
;// CONCATENATED MODULE: ./public/images/arrow_down.svg
/* harmony default export */ var arrow_down = ({"src":"/_next/static/media/arrow_down.af745ed1.svg","height":24,"width":24});
// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/image.js
var next_image = __webpack_require__(86430);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./hooks/usePopover.tsx
var usePopover = __webpack_require__(38737);
// EXTERNAL MODULE: ./containers/popover/popover.tsx
var popover = __webpack_require__(71048);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.39.3_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-query/es/index.js
var es = __webpack_require__(49532);
// EXTERNAL MODULE: ./services/request.ts
var request = __webpack_require__(47137);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+material@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+style_k46btafrtimgapyjpq7bbdyomu/node_modules/@mui/material/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(42041);
// EXTERNAL MODULE: ./node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/CheckboxCircleFillIcon.js
var CheckboxCircleFillIcon = __webpack_require__(32908);
var CheckboxCircleFillIcon_default = /*#__PURE__*/__webpack_require__.n(CheckboxCircleFillIcon);
// EXTERNAL MODULE: ./node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/CheckboxBlankCircleLineIcon.js
var CheckboxBlankCircleLineIcon = __webpack_require__(89099);
var CheckboxBlankCircleLineIcon_default = /*#__PURE__*/__webpack_require__.n(CheckboxBlankCircleLineIcon);
;// CONCATENATED MODULE: ./components/asyncSelect/asyncSelect.tsx












function AsyncSelect(param) {
    let { queryKey , extractTitle , extractKey , label , icon , value , onChange , filter , fullWidth =false  } = param;
    var ref;
    const [open, anchor, handleOpen, handleClose] = (0,usePopover/* default */.Z)();
    const { data , isLoading  } = (0,es.useInfiniteQuery)({
        queryKey,
        queryFn: ()=>request/* default.get */.Z.get(queryKey),
        enabled: open,
        staleTime: 0
    });
    let extractedData = (data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : ref.flatMap((item)=>{
        return (item === null || item === void 0 ? void 0 : item.data) || [];
    })) || [];
    if (filter) {
        extractedData = extractedData.filter(filter);
    }
    const handleChange = (item)=>{
        handleClose();
        if (onChange) {
            onChange(item);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((asyncSelect_module_default()).container, " ").concat(fullWidth && (asyncSelect_module_default()).fullWidth),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: (asyncSelect_module_default()).button,
                type: "button",
                onClick: handleOpen,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (asyncSelect_module_default()).mainContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (asyncSelect_module_default()).iconContainer,
                                children: icon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    label && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (asyncSelect_module_default()).label,
                                        children: [
                                            label,
                                            " "
                                        ]
                                    }),
                                    value && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: (asyncSelect_module_default()).value,
                                        children: [
                                            "- ",
                                            extractTitle(value)
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "".concat((asyncSelect_module_default()).dropdownIcon, " ").concat(open && (asyncSelect_module_default()).open),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: arrow_down,
                            alt: "arrow",
                            width: 24,
                            height: 24
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover["default"], {
                open: open,
                anchorEl: anchor,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 70,
                    horizontal: 0
                },
                customStyles: {
                    borderRadius: "15px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (asyncSelect_module_default()).popoverContainer,
                    children: [
                        isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                            size: 20
                        }),
                        extractedData.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                type: "button",
                                className: (asyncSelect_module_default()).row,
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    handleChange(item);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (asyncSelect_module_default()).radio,
                                        children: extractKey(item) === extractKey(value) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (asyncSelect_module_default()).checked,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((CheckboxCircleFillIcon_default()), {})
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (asyncSelect_module_default()).blank,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((CheckboxBlankCircleLineIcon_default()), {})
                                        })
                                    }),
                                    extractTitle(item)
                                ]
                            }, extractKey(item)))
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 90149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ profileDropdownLinks; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var remixicon_react_Store2LineIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40956);
/* harmony import */ var remixicon_react_Store2LineIcon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Store2LineIcon__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var remixicon_react_FileList2LineIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75799);
/* harmony import */ var remixicon_react_FileList2LineIcon__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_FileList2LineIcon__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var remixicon_react_StoreLineIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64409);
/* harmony import */ var remixicon_react_StoreLineIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_StoreLineIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var remixicon_react_HeartLineIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63079);
/* harmony import */ var remixicon_react_HeartLineIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_HeartLineIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var remixicon_react_EyeLineIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12923);
/* harmony import */ var remixicon_react_EyeLineIcon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_EyeLineIcon__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var remixicon_react_UserLineIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44237);
/* harmony import */ var remixicon_react_UserLineIcon__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_UserLineIcon__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var remixicon_react_Settings3FillIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50834);
/* harmony import */ var remixicon_react_Settings3FillIcon__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Settings3FillIcon__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var remixicon_react_Refund2LineIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14252);
/* harmony import */ var remixicon_react_Refund2LineIcon__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Refund2LineIcon__WEBPACK_IMPORTED_MODULE_8__);









const profileDropdownLinks = [
    {
        label: "shops",
        href: "/shop",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Store2LineIcon__WEBPACK_IMPORTED_MODULE_1___default()), {
            size: 24
        }),
        requiredAuth: false
    },
    {
        label: "order.history",
        href: "/orders",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_FileList2LineIcon__WEBPACK_IMPORTED_MODULE_2___default()), {
            size: 24
        }),
        requiredAuth: true
    },
    {
        label: "refund.orders",
        href: "/orders/refunds",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Refund2LineIcon__WEBPACK_IMPORTED_MODULE_8___default()), {
            size: 24
        }),
        requiredAuth: true
    },
    {
        label: "liked.shops",
        href: "/liked/shops",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_StoreLineIcon__WEBPACK_IMPORTED_MODULE_3___default()), {
            size: 24
        }),
        requiredAuth: false
    },
    {
        label: "liked.products",
        href: "/liked/products",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_HeartLineIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
            size: 24
        }),
        requiredAuth: false
    },
    {
        label: "viewed.products",
        href: "/product/viewed",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_EyeLineIcon__WEBPACK_IMPORTED_MODULE_5___default()), {
            size: 24
        }),
        requiredAuth: false
    },
    {
        label: "profile.settings",
        href: "/profile",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_UserLineIcon__WEBPACK_IMPORTED_MODULE_6___default()), {
            size: 24
        }),
        requiredAuth: true
    },
    {
        label: "site.settings",
        href: "/settings",
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Settings3FillIcon__WEBPACK_IMPORTED_MODULE_7___default()), {
            size: 24
        }),
        requiredAuth: false
    }
];


/***/ }),

/***/ 10299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SEO; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74549);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5125);
/* harmony import */ var constants_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66750);
/* harmony import */ var contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8854);





function SEO(param) {
    let { title , description =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_DESCRIPTION */ .KM , image =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_IMAGE */ .T5 , keywords =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_KEYWORDS */ .cU  } = param;
    const { settings  } = (0,contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_4__/* .useSettings */ .r)();
    const projectTitle = (settings === null || settings === void 0 ? void 0 : settings.title) || constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_TITLE */ .k5;
    const currentURL = constants_constants__WEBPACK_IMPORTED_MODULE_2__/* .WEBSITE_URL */ .o6;
    const siteTitle = title ? title + " | " + projectTitle : projectTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "Website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                property: "og:title",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                property: "og:author",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: (settings === null || settings === void 0 ? void 0 : settings.favicon) || "/favicon.png"
            })
        ]
    });
}


/***/ }),

/***/ 72059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SettingsContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var containers_sidebar_sidebar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(490);
/* harmony import */ var _settings_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19814);
/* harmony import */ var _settings_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_settings_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9120);





function SettingsContainer(param) {
    let { children  } = param;
    const isDesktop = (0,_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("(min-width:1024px)");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
        className: "container",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_settings_module_scss__WEBPACK_IMPORTED_MODULE_4___default().container),
            children: [
                isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_settings_module_scss__WEBPACK_IMPORTED_MODULE_4___default().sidebar),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(containers_sidebar_sidebar__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                withLinks: true
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_settings_module_scss__WEBPACK_IMPORTED_MODULE_4___default().line)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_settings_module_scss__WEBPACK_IMPORTED_MODULE_4___default().body),
                    children: react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, (child)=>child ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(child) : null)
                })
            ]
        })
    });
}


/***/ }),

/***/ 490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Sidebar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var _sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(83807);
/* harmony import */ var _sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6339);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53218);
/* harmony import */ var remixicon_react_Store2FillIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64473);
/* harmony import */ var remixicon_react_Store2FillIcon__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Store2FillIcon__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var remixicon_react_Heart3LineIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44900);
/* harmony import */ var remixicon_react_Heart3LineIcon__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_Heart3LineIcon__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var remixicon_react_CustomerServiceLineIcon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54727);
/* harmony import */ var remixicon_react_CustomerServiceLineIcon__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_CustomerServiceLineIcon__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var remixicon_react_ArrowRightSLineIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19457);
/* harmony import */ var remixicon_react_ArrowRightSLineIcon__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_ArrowRightSLineIcon__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var remixicon_react_LogoutCircleRLineIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55925);
/* harmony import */ var remixicon_react_LogoutCircleRLineIcon__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_LogoutCircleRLineIcon__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var utils_scrollToView__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(59778);
/* harmony import */ var contexts_auth_auth_context__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77712);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21867);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var remixicon_react_LoginCircleLineIcon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99232);
/* harmony import */ var remixicon_react_LoginCircleLineIcon__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(remixicon_react_LoginCircleLineIcon__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50959);
/* harmony import */ var components_profileDropdown_profileDropdownLinks__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(90149);















function Sidebar(param) {
    let { data , withLinks =false , onClose  } = param;
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)();
    const { query , pathname  } = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();
    const { logout , isAuthenticated , openAuthModal  } = (0,contexts_auth_auth_context__WEBPACK_IMPORTED_MODULE_8__/* .useAuth */ .a)();
    const links = (0,react__WEBPACK_IMPORTED_MODULE_11__.useMemo)(()=>{
        if (isAuthenticated) {
            return components_profileDropdown_profileDropdownLinks__WEBPACK_IMPORTED_MODULE_12__/* .profileDropdownLinks.filter */ .a.filter((item)=>item.href !== "/shop");
        }
        return components_profileDropdown_profileDropdownLinks__WEBPACK_IMPORTED_MODULE_12__/* .profileDropdownLinks.filter */ .a.filter((item)=>!item.requiredAuth && item.href !== "/shop");
    }, [
        isAuthenticated
    ]);
    const handleLogout = ()=>{
        logout();
    };
    const handleClose = ()=>{
        if (onClose) {
            onClose();
        }
    };
    const renderAuthButton = ()=>{
        if (!isAuthenticated) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                type: "button",
                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().link),
                onClick: ()=>openAuthModal(),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().body),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_LoginCircleLineIcon__WEBPACK_IMPORTED_MODULE_10___default()), {
                                size: 24
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: t("login")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_ArrowRightSLineIcon__WEBPACK_IMPORTED_MODULE_6___default()), {
                        size: 20
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
            type: "button",
            className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().link),
            onClick: handleLogout,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().body),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_LogoutCircleRLineIcon__WEBPACK_IMPORTED_MODULE_7___default()), {
                            size: 24
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: t("log.out")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_ArrowRightSLineIcon__WEBPACK_IMPORTED_MODULE_6___default()), {
                    size: 20
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("aside", {
        className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().links),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/shop",
                        className: "".concat((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().link), " ").concat(pathname === "/shop" && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().active)),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().body),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Store2FillIcon__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    size: 24
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: t("shops")
                                })
                            ]
                        })
                    }),
                    !withLinks && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: {
                            pathname: "/liked/products",
                            query: {
                                shop_id: query === null || query === void 0 ? void 0 : query.id
                            }
                        },
                        className: "".concat((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().link), " ").concat(pathname.includes("/liked/products") && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().active)),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().body),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_Heart3LineIcon__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    size: 24
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: t("liked.products")
                                })
                            ]
                        })
                    }),
                    withLinks && links.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: item.href,
                            className: "".concat((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().link), " ").concat(pathname === item.href && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().active)),
                            onClick: handleClose,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().body),
                                children: [
                                    item.icon,
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: t(item.label)
                                    })
                                ]
                            })
                        }, item.href))
                ]
            }),
            !!(data === null || data === void 0 ? void 0 : data.length) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().categoryContainer),
                children: data === null || data === void 0 ? void 0 : data.map((category)=>{
                    var ref;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: ()=>{
                            return (0,utils_scrollToView__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(category === null || category === void 0 ? void 0 : category.uuid, -70);
                        },
                        type: "button",
                        className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().category),
                        children: category === null || category === void 0 ? void 0 : (ref = category.translation) === null || ref === void 0 ? void 0 : ref.title
                    }, category === null || category === void 0 ? void 0 : category.id);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().links),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/help",
                        className: "".concat((_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().link), " ").concat(pathname.includes("/help") && (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().active)),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_sidebar_module_scss__WEBPACK_IMPORTED_MODULE_13___default().body),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_CustomerServiceLineIcon__WEBPACK_IMPORTED_MODULE_5___default()), {
                                        size: 24
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: t("help.center")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((remixicon_react_ArrowRightSLineIcon__WEBPACK_IMPORTED_MODULE_6___default()), {
                                size: 20
                            })
                        ]
                    }),
                    renderAuthButton()
                ]
            })
        ]
    });
}


/***/ }),

/***/ 68864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useModal; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);

function useModal() {
    let isOpen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    const [open, setOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(isOpen);
    const handleOpen = (event)=>{
        event === null || event === void 0 ? void 0 : event.preventDefault();
        setOpen(true);
    };
    const handleClose = ()=>setOpen(false);
    return [
        open,
        handleOpen,
        handleClose
    ];
}


/***/ }),

/***/ 81247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ SettingsPage; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./components/seo.tsx
var seo = __webpack_require__(10299);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-i18next@12.3.1_i18next@22.5.1_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-i18next/dist/es/index.js + 17 modules
var es = __webpack_require__(53218);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.39.3_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(49532);
// EXTERNAL MODULE: ./services/address.ts
var address = __webpack_require__(1988);
// EXTERNAL MODULE: ./contexts/auth/auth.context.tsx
var auth_context = __webpack_require__(77712);
// EXTERNAL MODULE: ./contexts/settings/settings.context.tsx
var settings_context = __webpack_require__(8854);
// EXTERNAL MODULE: ./components/addressList/addressList.tsx + 1 modules
var addressList = __webpack_require__(45441);
// EXTERNAL MODULE: ./components/settings/settings.module.scss
var settings_module = __webpack_require__(90012);
var settings_module_default = /*#__PURE__*/__webpack_require__.n(settings_module);
// EXTERNAL MODULE: ./hooks/useAddressServices.tsx
var useAddressServices = __webpack_require__(66886);
// EXTERNAL MODULE: ./components/asyncSelect/asyncSelect.tsx + 1 modules
var asyncSelect = __webpack_require__(43276);
// EXTERNAL MODULE: ./node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/GlobalLineIcon.js
var GlobalLineIcon = __webpack_require__(73652);
var GlobalLineIcon_default = /*#__PURE__*/__webpack_require__.n(GlobalLineIcon);
// EXTERNAL MODULE: ./node_modules/.pnpm/nprogress@0.2.0/node_modules/nprogress/nprogress.js
var nprogress = __webpack_require__(29981);
var nprogress_default = /*#__PURE__*/__webpack_require__.n(nprogress);
// EXTERNAL MODULE: ./services/translations.ts
var translations = __webpack_require__(78513);
// EXTERNAL MODULE: ./utils/session.ts + 1 modules
var session = __webpack_require__(75129);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./contexts/theme/theme.context.tsx
var theme_context = __webpack_require__(81803);
// EXTERNAL MODULE: ./hooks/useRedux.tsx
var useRedux = __webpack_require__(46496);
// EXTERNAL MODULE: ./redux/slices/currency.ts
var slices_currency = __webpack_require__(23102);
// EXTERNAL MODULE: ./node_modules/.pnpm/remixicon-react@1.0.0_react@18.2.0/node_modules/remixicon-react/CoinLineIcon.js
var CoinLineIcon = __webpack_require__(8268);
var CoinLineIcon_default = /*#__PURE__*/__webpack_require__.n(CoinLineIcon);
// EXTERNAL MODULE: ./node_modules/.pnpm/@mui+system@5.18.0_@emotion+react@11.14.0_@types+react@18.3.28_react@18.2.0__@emotion+styled@_oja7ubotzrzctrclxreoqqilcu/node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(9120);
// EXTERNAL MODULE: ./hooks/useLocale.tsx
var useLocale = __webpack_require__(46405);
;// CONCATENATED MODULE: ./components/settings/settings.tsx





















function Settings() {
    const { t , i18n  } = (0,es/* useTranslation */.$G)();
    const dispatch = (0,useRedux/* useAppDispatch */.T)();
    const { isAuthenticated , user  } = (0,auth_context/* useAuth */.a)();
    const { updateAddress , updateLocation , updateLocationId  } = (0,settings_context/* useSettings */.r)();
    const currency = (0,useRedux/* useAppSelector */.C)(slices_currency/* selectCurrency */.j);
    const { setDirection  } = (0,react.useContext)(theme_context/* ThemeContext */.N);
    const isMobile = (0,useMediaQuery/* default */.Z)("(max-width: 640px)");
    const { addResourceBundle  } = (0,useLocale/* default */.Z)();
    const { mutate: changeServerActiveAddress  } = (0,useAddressServices/* useChangeAddress */.t)();
    const { data: serverAddresses  } = (0,react_query_es.useQuery)({
        queryKey: [
            "addresses",
            isAuthenticated,
            user === null || user === void 0 ? void 0 : user.id
        ],
        queryFn: ()=>address/* default.getAll */.Z.getAll({
                perPage: 100
            }),
        enabled: isAuthenticated,
        staleTime: 0
    });
    const activeAddress = serverAddresses === null || serverAddresses === void 0 ? void 0 : serverAddresses.find((item)=>{
        return item === null || item === void 0 ? void 0 : item.active;
    });
    const handleChangeAddress = (item)=>{
        var ref;
        if (!(item === null || item === void 0 ? void 0 : item.id)) return;
        changeServerActiveAddress(item === null || item === void 0 ? void 0 : item.id);
        updateAddress((ref = item.address) === null || ref === void 0 ? void 0 : ref.address);
        updateLocation(item.location.join(","));
        updateLocationId(item.id.toString());
    };
    const handleChangeLanguage = (item)=>{
        const isRTL = item === null || item === void 0 ? void 0 : item.backward;
        const lang = item === null || item === void 0 ? void 0 : item.locale;
        i18n.changeLanguage(item.locale);
        nprogress_default().start();
        translations/* default.getAll */.Z.getAll({
            lang
        }).then((param)=>{
            let { data  } = param;
            return addResourceBundle(lang, "translation", data);
        }).finally(()=>{
            (0,session/* setCookie */.d8)("locale", lang);
            i18n.changeLanguage(lang);
            setDirection(isRTL ? "rtl" : "ltr");
            nprogress_default().done();
        });
    };
    const handleChangeCurrency = (item)=>{
        dispatch((0,slices_currency/* setCurrency */.NW)(item));
        (0,session/* setCookie */.d8)("currency_id", item === null || item === void 0 ? void 0 : item.id);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (settings_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: (settings_module_default()).mainTitle,
                children: t("site.settings")
            }),
            isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (settings_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (settings_module_default()).title,
                        children: t("saved.locations")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (settings_module_default()).body,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(addressList/* default */.Z, {
                            data: serverAddresses || [],
                            changeAddress: handleChangeAddress,
                            selectedAddressId: activeAddress === null || activeAddress === void 0 ? void 0 : activeAddress.id
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (settings_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (settings_module_default()).title,
                        children: t("interface")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (settings_module_default()).body,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(asyncSelect/* default */.Z, {
                                queryKey: "/rest/languages/active",
                                extractTitle: (data)=>{
                                    var ref;
                                    return data === null || data === void 0 ? void 0 : (ref = data.locale) === null || ref === void 0 ? void 0 : ref.toUpperCase();
                                },
                                extractKey: (data)=>{
                                    return data === null || data === void 0 ? void 0 : data.locale;
                                },
                                label: t("language"),
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((GlobalLineIcon_default()), {
                                    size: 24
                                }),
                                value: {
                                    locale: i18n.language
                                },
                                onChange: handleChangeLanguage,
                                fullWidth: isMobile
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(asyncSelect/* default */.Z, {
                                queryKey: "/rest/currencies/active",
                                extractTitle: (data)=>{
                                    return "".concat(data === null || data === void 0 ? void 0 : data.title, " - (").concat(data === null || data === void 0 ? void 0 : data.symbol, ")");
                                },
                                extractKey: (data)=>{
                                    return data === null || data === void 0 ? void 0 : data.id;
                                },
                                label: t("currency"),
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((CoinLineIcon_default()), {
                                    size: 24
                                }),
                                value: currency,
                                onChange: handleChangeCurrency,
                                fullWidth: isMobile
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./containers/settings/settings.tsx
var settings = __webpack_require__(72059);
;// CONCATENATED MODULE: ./pages/settings/index.tsx





function SettingsPage() {
    const { t  } = (0,es/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* default */.Z, {
                title: t("settings")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(settings/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Settings, {})
            })
        ]
    });
}


/***/ }),

/***/ 59778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ scrollToView; }
/* harmony export */ });
function scrollToView(uuid) {
    let yOffset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (!uuid) {
        return;
    }
    const element = document.getElementById(uuid);
    if (element) {
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({
            top: y,
            behavior: "smooth"
        });
    } else {
        var ref, ref1;
        window.location.hash = uuid;
        const element1 = document.getElementById("the-end");
        const y1 = (element1 === null || element1 === void 0 ? void 0 : (ref = element1.getBoundingClientRect) === null || ref === void 0 ? void 0 : (ref1 = ref.call(element1)) === null || ref1 === void 0 ? void 0 : ref1.top) + window.pageYOffset + yOffset;
        window.scrollTo({
            top: y1,
            behavior: "smooth"
        });
    }
}


/***/ }),

/***/ 25898:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"asyncSelect_container__hyrY2","fullWidth":"asyncSelect_fullWidth__FxcXG","button":"asyncSelect_button__qZtcZ","mainContainer":"asyncSelect_mainContainer__hDU9P","iconContainer":"asyncSelect_iconContainer__inTKt","label":"asyncSelect_label__UoaRd","value":"asyncSelect_value__7n0Tv","dropdownIcon":"asyncSelect_dropdownIcon__u8oZC","open":"asyncSelect_open__pVYd8","popoverContainer":"asyncSelect_popoverContainer__jmSsR","row":"asyncSelect_row__I1cjm","radio":"asyncSelect_radio__PineF","checked":"asyncSelect_checked__seIo6","blank":"asyncSelect_blank__byvvt"};

/***/ }),

/***/ 90012:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"settings_wrapper___oi5H","container":"settings_container__vJvm9","body":"settings_body__SwTuT","title":"settings_title__u_yog","mainTitle":"settings_mainTitle__ypS3c"};

/***/ }),

/***/ 19814:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"settings_container__rObHi","sidebar":"settings_sidebar____hs3","line":"settings_line__zzjer","body":"settings_body__uMN7T"};

/***/ }),

/***/ 83807:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"sidebar_container__IjaDC","links":"sidebar_links__LM_pw","link":"sidebar_link__6YsEF","body":"sidebar_body__cwbZC","active":"sidebar_active__rrguH","categoryContainer":"sidebar_categoryContainer__3wSEp","category":"sidebar_category__b_8_c"};

/***/ }),

/***/ 74549:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5451)


/***/ }),

/***/ 19457:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(50959);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var ArrowRightSLineIcon = function ArrowRightSLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z' })
  );
};

var ArrowRightSLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(ArrowRightSLineIcon) : ArrowRightSLineIcon;

module.exports = ArrowRightSLineIcon$1;


/***/ }),

/***/ 89099:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(50959);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var CheckboxBlankCircleLineIcon = function CheckboxBlankCircleLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z' })
  );
};

var CheckboxBlankCircleLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(CheckboxBlankCircleLineIcon) : CheckboxBlankCircleLineIcon;

module.exports = CheckboxBlankCircleLineIcon$1;


/***/ }),

/***/ 32908:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(50959);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var CheckboxCircleFillIcon = function CheckboxCircleFillIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-.997-6l7.07-7.071-1.414-1.414-5.656 5.657-2.829-2.829-1.414 1.414L11.003 16z' })
  );
};

var CheckboxCircleFillIcon$1 = React__default['default'].memo ? React__default['default'].memo(CheckboxCircleFillIcon) : CheckboxCircleFillIcon;

module.exports = CheckboxCircleFillIcon$1;


/***/ }),

/***/ 8268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(50959);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var CoinLineIcon = function CoinLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M12 4c6.075 0 11 2.686 11 6v4c0 3.314-4.925 6-11 6-5.967 0-10.824-2.591-10.995-5.823L1 14v-4c0-3.314 4.925-6 11-6zm0 12c-3.72 0-7.01-1.007-9-2.55V14c0 1.882 3.883 4 9 4 5.01 0 8.838-2.03 8.995-3.882L21 14l.001-.55C19.011 14.992 15.721 16 12 16zm0-10c-5.117 0-9 2.118-9 4 0 1.882 3.883 4 9 4s9-2.118 9-4c0-1.882-3.883-4-9-4z' })
  );
};

var CoinLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(CoinLineIcon) : CoinLineIcon;

module.exports = CoinLineIcon$1;


/***/ }),

/***/ 13035:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(50959);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var DeleteBinLineIcon = function DeleteBinLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M17 6h5v2h-2v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V8H2V6h5V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3zm1 2H6v12h12V8zm-9 3h2v6H9v-6zm4 0h2v6h-2v-6zM9 4v2h6V4H9z' })
  );
};

var DeleteBinLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(DeleteBinLineIcon) : DeleteBinLineIcon;

module.exports = DeleteBinLineIcon$1;


/***/ }),

/***/ 73652:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(50959);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var GlobalLineIcon = function GlobalLineIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['color', 'size', 'children']);

  var className = 'remixicon-icon ' + (props.className || '');

  return React__default['default'].createElement(
    'svg',
    _extends({}, props, { className: className, width: size, height: size, fill: color, viewBox: '0 0 24 24' }),
    React__default['default'].createElement('path', { d: 'M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-2.29-2.333A17.9 17.9 0 0 1 8.027 13H4.062a8.008 8.008 0 0 0 5.648 6.667zM10.03 13c.151 2.439.848 4.73 1.97 6.752A15.905 15.905 0 0 0 13.97 13h-3.94zm9.908 0h-3.965a17.9 17.9 0 0 1-1.683 6.667A8.008 8.008 0 0 0 19.938 13zM4.062 11h3.965A17.9 17.9 0 0 1 9.71 4.333 8.008 8.008 0 0 0 4.062 11zm5.969 0h3.938A15.905 15.905 0 0 0 12 4.248 15.905 15.905 0 0 0 10.03 11zm4.259-6.667A17.9 17.9 0 0 1 15.973 11h3.965a8.008 8.008 0 0 0-5.648-6.667z' })
  );
};

var GlobalLineIcon$1 = React__default['default'].memo ? React__default['default'].memo(GlobalLineIcon) : GlobalLineIcon;

module.exports = GlobalLineIcon$1;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9134,8,8396,9164,5441,9774,2888,179], function() { return __webpack_exec__(31508); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);